

$(document).ready(function () {

  // *************************
  // SVG Loader - https://github.com/iconic/SVGInjector
  // *************************
  var mySVGsToInject = document.querySelectorAll('svg[data-src]');
  SVGInjector(mySVGsToInject);

  // *************************
  // MiniCart
  // *************************

  // Prevent native submissions even when Alpine stops click bubbling on shade cards.
  document.addEventListener('click', event => {
    if (event.target.closest('[data-add-to-cart]')) event.preventDefault();
  }, true);
  // All cart mutations share the same queue, including legacy product buttons.
  $('body').on('click', '[data-add-to-cart]', function(event) {
    event.preventDefault();
    addToCart(this);
  });
  document.addEventListener('add_to_cart', event => {
    const element = event.detail && event.detail.element;
    if (element) addToCart(element);
  });
  $('body').on('click', '[data-remove-cart-item]', function(event) {
    event.preventDefault();
    updateCartItem(this.getAttribute('data-remove-cart-item'), 0);
  });
  $('body').on('click', '[data-change-cart-item-quantity]', function(event) {
    event.preventDefault();
    updateCartItem(this.getAttribute('data-cart-item'), this.getAttribute('data-change-cart-item-quantity'));
  });
  async function addToCart(element) {
    if (element.dataset.cartBusy === 'true') return;
    const focusReturn = element;
    element.dataset.cartBusy = 'true';
    const disabled = element.disabled;
    element.disabled = true;
    try {
      await WBCart.enqueue(async () => {
        try {
          await WBCart.addItems([{id: element.getAttribute('data-product-id'), quantity: element.getAttribute('data-product-qty') || element.getAttribute('data-quantity') || 1}], {emitUpdate: false});
        } catch (error) {
          // Shopify can add the remaining stock before returning a 422 response.
          // Refresh inside this operation so later mutations wait for reconciliation.
          if (Number(error.status) === 422) {
            try {
              WBCart.dispatchUpdated(await WBCart.getCart());
            } catch (refreshError) {
              console.error('Cart refresh after stock error failed', refreshError);
              window.dispatchEvent(new CustomEvent('cart:refresh-error', {detail: {}}));
            }
          }
          throw error;
        }
        const cart = await WBCart.getCart();
        WBCart.dispatchUpdated(cart);
        window.dispatchEvent(new CustomEvent('close-modals', {detail: {reason: 'cart-add'}}));
        WBCart.dispatchMinicartRefresh(true, focusReturn);
      });
    } catch (error) { cartFail(error); }
    finally { element.disabled = disabled; delete element.dataset.cartBusy; }
  }
  async function updateCartItem(id, quantity) {
    try {
      await WBCart.enqueue(() => WBCart.changeCart({id: id, quantity: Number(quantity)}));
    } catch (error) { cartFail(error); }
  }
  function cartFail(error) {
    console.error('Cart request failed', error);
    window.dispatchEvent(new CustomEvent('show-msg', {detail: {
      open: true, bgcolor: 'bg-red-500', textcolor: 'text-white',
      content: error.status === 422 && error.customerMessage ? error.customerMessage : window.WBCartCopy.error
    }}));
  }

  // *************************
  // Check if element exists using mutation observer
  // https://gist.github.com/jwilson8767/db379026efcbd932f64382db4b02853e
  // *************************
  // function elementReady(selector) {
  //   return new Promise((resolve, reject) => {
  //     let el = document.querySelector(selector);
  //     if (el) {resolve(el);}
  //     new MutationObserver((mutationRecords, observer) => {
  //       Array.from(document.querySelectorAll(selector)).forEach((element) => {
  //         resolve(element);
  //         observer.disconnect();
  //       });
  //     })
  //     .observe(document.documentElement, {
  //       childList: true,
  //       subtree: true
  //     });
  //   });
  // }

  // *************************
  // Form Validation
  // *************************
  var emailValidations ={
    email: [/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, 'Veuillez saisir une adresse e-mail valide.']
  };

  // Check all the input fields of type email. This function will handle all the email addresses validations
  $("input[type=email]").change( function(){
    // Set the regular expression to validate the email 
    validation = new RegExp(emailValidations['email'][0]);
    // validate the email value against the regular expression
    if (!validation.test(this.value)){
      // If the validation fails then we show the custom error message
      this.setCustomValidity(emailValidations['email'][1]);
      return false;
    } else {
      // This is really important. If the validation is successful you need to reset the custom error message
      this.setCustomValidity('');
    }
  });

});